import type { Selo } from './useSelos.ts'
import './selos.css'

/**
 * Os selos de plugin de UM card (SPEC-20260926-2036-plugin-acao-e-selo).
 *
 * Sem selo, não renderiza nada — nem um espaço vazio. O card precisa parecer
 * igual em quadro sem plugin nenhum.
 *
 * O texto vem de terceiro, então: recortado no servidor (40 caracteres) e
 * exibido como TEXTO, nunca como marcação. A cor acompanha, mas nunca informa
 * sozinha — o selo sempre tem palavra.
 */
export function SelosDoCard({ selos }: { selos: readonly Selo[] | undefined }) {
  if (!selos || selos.length === 0) return null
  return (
    <>
      {selos.map((s, i) => (
        <span
          key={`${s.workItemId}-${i}`}
          className={`kb__pluginselo kb__pluginselo--${s.tone}`}
          title={s.titulo ?? s.texto}
        >
          {s.texto}
        </span>
      ))}
    </>
  )
}
